import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  alpha,
  CircularProgress,
  Typography,
} from "@mui/material";
import { BASE_PATHS, SUB_PATHS } from "app/utils/constants/routeConstants";
import JumboListNoDataPlaceholder from "@jumbo/components/JumboList/components/JumboListNoDataPlaceHolder";
import StyledTableCell from "components/common/StyledTableCell";
import Div from "@jumbo/shared/Div";
import ListActionButtons from "components/ActionButtons/ListActionButtons";

const ContentTable = ({
  contents,
  error,
  languages,
  statusOptions,
  navigate,
  loading,
}) => {
  const [hoveredRow, setHoveredRow] = useState(null);

  const getLanguageDisplay = (languageKey) => {
    const language = languages.find((l) => l.key === languageKey);
    return language ? language.value : languageKey || "Unknown";
  };

  const getStatusDisplay = (statusKey) => {
    const status = statusOptions.find((s) => s.key === statusKey);
    return status ? status.value : statusKey || "Unknown";
  };

  const handleView = (content) => {
    const languageName = getLanguageDisplay(content.language).toLowerCase();
    navigate(
      `${BASE_PATHS.PROGRAMMING_CONTENT}/${languageName}/${content.url}`
    );
  };

  const handleEdit = (content) => {
    navigate(
      `${BASE_PATHS.ADMIN_PROGRAMMING_CONTENT}/${SUB_PATHS.UPDATE_CONTENT}/${content.id}`,
      {
        state: { content },
      }
    );
  };

  const handleDelete = (content) => {
    // TODO: Implement delete functionality
    alert(`🎉Successfully deleted ${content.title}`);
  };

  return (
    <TableContainer sx={{ minHeight: 440, flexGrow: 1 }}>
      {loading ? (
        <Div
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            minWidth: 0,
            alignContent: "center",
            height: "100vh",
          }}
        >
          <CircularProgress sx={{ m: "-40px auto 0" }} />
          <Typography variant="body1" color="text.secondary">
            Loading problems...
          </Typography>
        </Div>
      ) : error ? (
        <Div sx={{ textAlign: "center", p: 3 }}>Error: {error}</Div>
      ) : contents.length === 0 ? (
        <JumboListNoDataPlaceholder text="No content found" />
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Title</StyledTableCell>
              <StyledTableCell>Programming Language</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {contents.map((content) => (
              <TableRow
                key={content.id}
                hover
                onClick={() => handleView(content)}
                onMouseEnter={() => setHoveredRow(content.id)}
                onMouseLeave={() => setHoveredRow(null)}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: `0 3px 1px 0 ${alpha("#000", 0.1)}`,
                    borderBottomColor: "transparent",
                  },
                }}
              >
                <TableCell sx={{ width: 500 }}>{content.title}</TableCell>
                <TableCell sx={{ width: 250 }}>
                  {getLanguageDisplay(content.language)}
                </TableCell>
                <TableCell sx={{ width: 100 }}>
                  {getStatusDisplay(content.status)}
                </TableCell>
                <TableCell sx={{ width: 50, minHeight: 48 }}>
                  <ListActionButtons
                    row={content}
                    onView={handleView}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    showEdit={true}
                    showDelete={true}
                    isHovered={hoveredRow === content.id}
                    viewTooltip="View"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default ContentTable;
